import { Box } from '@mui/material';
import TableComponent from '../BillOfMaterials/TableComponent';
import { useEffect, useMemo, useState } from 'react';
import { useAtom } from 'jotai';
import setupAtoms, { getBomData, getcpChecklist } from '../../../atoms/setup/SetupAtoms';

const TrackerTable = ({ isAdding, setIsAdding, handleAddRow, newRow, setNewRow, tableHeaders }) => {
  const [data] = useAtom(setupAtoms);
  const [, setTrackerData] = useAtom(getBomData);
  const [, setChecklist] = useAtom(getcpChecklist);

  const [list, setList] = useState([]);
  const [loader, setLoader] = useState(false);

  const init = async () => {
    if (data?.bompertrackertypeData?.length) return;
    setLoader(true);
    try {
      await setTrackerData();
      await setChecklist();
    } catch (err) {
      console.error('Failed to load tracker data:', err);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const bomTrackerList = useMemo(() => {
    return Array.isArray(data?.bompertrackertypeData) ? data.bompertrackertypeData : [];
  }, [data?.bompertrackertypeData]);

  useEffect(() => {
    setList(bomTrackerList);
  }, [bomTrackerList]);

  return (
    <Box px={2}>
      <TableComponent 
        data={list} 
        loader={loader} 
        headers={tableHeaders} 
        isAdding={isAdding} 
        setIsAdding={setIsAdding}
        handleAddRow={handleAddRow}
        newRow={newRow}
        setNewRow={setNewRow}
        setLoader={setLoader}
        fetchCall={setTrackerData}
      />
    </Box>
  );
};

export default TrackerTable;
